"use client";

import React from 'react';
import { useCohesionEvents } from "@2u-landing-pages/aa/hooks/useCohesionEvents";
import { TWOU_CREATIVE_APP } from "@2u-landing-pages/constants/applicationNames";

interface UseCohesionEventsProps {
  lob: string;
  school: string;
  program: string;
  nameOverride?: string;
}

export const UseCohesionEvents = ({ lob, school, program, nameOverride }: UseCohesionEventsProps) => {
  useCohesionEvents(lob, school, program, nameOverride || `A/A ${school.toUpperCase()} ${program.toUpperCase()}`, TWOU_CREATIVE_APP);
  return (<></>);
};
